import type { AppCardData } from './types';

export const canShowAttentionStrip = (data: Pick<AppCardData, 'products' | 'taskCounts'>): boolean =>
  data.products.length > 0 && data.taskCounts.some((taskCount) => taskCount.count > 0);
